<template>
  <div class="loading-component-container">
    <div class="row">
      <div class="col-lg-7 col-12">
        <v-skeleton-loader
          class="mx-auto"
          elevation="2"
          max-width="90%"
          type="article, card-avatar, article, article, article"
        ></v-skeleton-loader>
      </div>
      <div class="col-lg-5 col-12">
        <v-skeleton-loader
          class="mx-auto"
          elevation="2"
          max-width="90%"
          type="article, article, article"
        ></v-skeleton-loader>
        <v-skeleton-loader
          class="mx-auto loading-component-spacer"
          elevation="2"
          max-width="90%"
          type="article"
        ></v-skeleton-loader>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoadingComponent",
};
</script>

<style></style>
